import Vue from 'vue';
import Customiser from './Customiser.vue';

const CustomiserApp = new Vue({
    el: '#vue-customiser-app',
    data: {
        product: '',
        range: '',
    },
    methods: {
        setProduct: function() {
            this.product = this.$refs.product.dataset.product;
        },
        setRange: function() {
            this.range = this.$refs.product.dataset.range;
        },
    },
    mounted: function () {
        this.setProduct();
        this.setRange();
    },
    components: {
        Customiser,
    }
});
